import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import {
  fetchResponseRatio,
  getResponseRatio,
  getActiveFiltersQueryParams,
} from 'state/Insights/InsightsSlice';
import { SLICE_STATUS } from 'utils/constants';
import ErrorScreen from '../../Components/ErrorScreen';
import BasicInfoLoader from '../../Components/SkeletonLoaders/BasicInfoLoader';
import ResponseRatioComponent from './ResponseRatioComponent';

const ResponseRatio = () => {
  const dispatch = useDispatch();
  const responseRatio = useSelector(getResponseRatio);
  const activeFilters = useSelector(getActiveFiltersQueryParams);

  useEffect(() => {
    dispatch(fetchResponseRatio(activeFilters));
  }, [dispatch, activeFilters]);

  const status = responseRatio.status;
  return (
    <div className='flex flex-col border rounded border-neutral-lighter-two rounded-lg shadow-allocation-table w-1/2'>
      {status === SLICE_STATUS.LOADING ? (
        <BasicInfoLoader />
      ) : status === SLICE_STATUS.FAILED ? (
        <ErrorScreen />
      ) : (
        <ResponseRatioComponent data={responseRatio} />
      )}
    </div>
  );
};

export default ResponseRatio;
